import { type FC } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

interface EngagementSectionPaginationProps {
  currentPage: number;
  totalPages: number;
  onPrev: () => void;
  onNext: () => void;
  ariaLabel: string;
}

const EngagementSectionPagination: FC<EngagementSectionPaginationProps> = ({
  currentPage,
  totalPages,
  onPrev,
  onNext,
  ariaLabel,
}) => {
  const safeTotal = Math.max(1, totalPages);
  const safeCurrent = Math.min(Math.max(1, currentPage), safeTotal);

  return (
    <nav className="engagement-overview-pagination" aria-label={ariaLabel}>
      <button
        type="button"
        className="engagement-overview-pagination__btn"
        onClick={onPrev}
        disabled={safeCurrent <= 1}
        aria-label="Previous page"
      >
        <ChevronLeft size={16} aria-hidden />
      </button>
      <span className="engagement-overview-visually-hidden engagement-overview-pagination__label">
        {`Page ${safeCurrent} of ${safeTotal}`}
      </span>
      <button
        type="button"
        className="engagement-overview-pagination__btn"
        onClick={onNext}
        disabled={safeCurrent >= safeTotal}
        aria-label="Next page"
      >
        <ChevronRight size={16} aria-hidden />
      </button>
    </nav>
  );
};

export default EngagementSectionPagination;
